import { useQuery } from 'data-fetching-client';
import { getUninstallableReason } from '../utils/installability';
import { GET_APP_INSTALLABILITY } from '../queries/appInstallabilityQuery';
export function useAppInstallability({
  appContext = 'app',
  // default to app context
  offeringId,
  published = true,
  features
}) {
  const {
    data: installabilityData,
    loading: installabilityLoading,
    error: installabilityError,
    refetch: installabilityRefetch
  } = useQuery(GET_APP_INSTALLABILITY, {
    variables: {
      appContext,
      offeringId,
      published
    },
    skip: !offeringId
  });
  const installability = installabilityData === null || installabilityData === void 0 ? void 0 : installabilityData.appInstallability;
  const uninstallableReason = installability && getUninstallableReason(installability, features);
  return {
    installability,
    installabilityError,
    installabilityLoading,
    installabilityRefetch,
    uninstallableReason
  };
}